function parseId(string: string, by: string) {
  if (typeof string === "string") {
    return string.split(by).at(-1);
  };

  return string;
};

export default parseId;
